export default [
  {
    path: '/engine/fields/:id',
    name: 'engine-field-edit',
    component: () => import('./Field.vue'),
    props: route => ({
      fieldId: route.params.id,
      fieldName: route.query.name || '',
      table: route.query.table || '',
      standalone: true,
    }),
    meta: { engine: true, requiresAdmin: true },
  },
  {
    path: '/engine/fields/:id/variants/:variant',
    name: 'engine-field-variant-edit',
    component: () => import('./editVariant.vue'),
    props: route => ({ fieldId: route.params.id, variant: route.params.variant, standalone: true }),
    meta: { engine: true, requiresAdmin: true },
  },
]
